import { animations } from '@assets';
import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { useLoader } from '@hooks';

import { Lottie } from '../../lottie';

export const GlobalLoader = () => {
	const { isVisible } = useLoader('global');

	return (
		<>
			{isVisible && (
				<Box
					styles={{
						display: 'block',
						position: 'fixed',
						zIndex: 10000,
						backgroundColor: '#3f3f3f71',
						backdropFilter: 'blur(10px)',
						width: '100vw',
						height: '100vh',
					}}
				>
					<Box
						styles={{
							height: '100%',
						}}
					>
						<Lottie
							animationData={animations.loader}
							width="120px"
							height="120px"
							styles={{
								margin: 'auto',
							}}
						/>
					</Box>
				</Box>
			)}
		</>
	);
};
